import { useReducedMotion } from "framer-motion";

export const SCALE_HOVER = 1.02;
export const SCALE_TAP = 0.97;
const SCALE_TRANSITION = { duration: 0.2 };

/**
 * framer-motion gesture props for a subtle interaction scale:
 *  - whileHover: grow slightly (desktop pointer only — touch devices never hover)
 *  - whileTap:   press-in (fires on mouse AND touch → tactile mobile feedback)
 * Pass hover:false / tap:false to omit either. No-ops under prefers-reduced-motion.
 * Spread the result onto a `component={motion.div}` element.
 */
export function useScaleGestures({ hover = SCALE_HOVER, tap = SCALE_TAP } = {}) {
  const reduce = useReducedMotion();
  if (reduce) return {};

  const gestures = {};
  if (hover) gestures.whileHover = { scale: hover, transition: SCALE_TRANSITION };
  if (tap) gestures.whileTap = { scale: tap, transition: SCALE_TRANSITION };
  return gestures;
}
